
import { Options, prop, Vue } from 'vue-class-component';

class Props {
  isDisabledEditBtn = prop<boolean>({
    default: false,
    type: Boolean
  });
  originCityCode = prop<string>({
    default: "",
    type: String
  });
  destinationCityCode = prop<string>({
    default: "",
    type: String
  });
  cargoType = prop<string>({
    default: "",
    type: String
  });
  id = prop<string>({
    default: "",
    type: String
  });
  no = prop<string>({
    default: "",
    type: String
  });
}

@Options({})
class CargoV2EditLayout extends Vue.with(Props) {}
export default CargoV2EditLayout;
